import { InvitacionService } from './src/services/invitaciones.services';

export type { Invitacion, GrupoInvitacion } from './src/services/suite.interfaces';

export const invitacionService = new InvitacionService();

export default invitacionService;
